import { useEffect, useState } from "react";
import { Bell } from "@phosphor-icons/react";
import { settingsApi } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function Topbar({ title, subtitle, actions }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => { settingsApi.get().then(setSettings).catch(() => {}); }, []);

  return (
    <header
      data-testid="topbar"
      className="sticky top-0 z-20 backdrop-blur-xl bg-background/70 border-b border-border"
    >
      <div className="flex items-center justify-between px-6 lg:px-10 py-5">
        <div>
          <h1 className="font-display text-3xl lg:text-4xl font-semibold text-foreground leading-tight">{title}</h1>
          {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-3">
          {settings && (
            <Badge
              data-testid="twilio-status-badge"
              variant={settings.twilio_configured ? "default" : "secondary"}
              className={settings.twilio_configured
                ? "bg-success text-white"
                : "bg-muted text-muted-foreground border border-border"}
            >
              {settings.twilio_configured ? "Twilio Live" : "Simulation Mode"}
            </Badge>
          )}
          {actions}
          <button
            data-testid="notifications-button"
            className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-border bg-card hover:bg-muted transition-colors"
            aria-label="Notifications"
          >
            <Bell className="h-[18px] w-[18px]" weight="duotone" />
          </button>
        </div>
      </div>
    </header>
  );
}
